import React, { useEffect, useState } from 'react';
import {
  LogOut,
  User,
  ShieldCheck,
  Settings,
  FileSearch2,
  Clock,
  Menu,
  ActivitySquare,
  ListMusic,
  Voicemail,
  PhoneIncoming,
  PhoneForwarded,
  UsersRound,
  DollarSign,
  Banknote,
  Network,
  Radio,
} from 'lucide-react';
import getClientConfig from '../config';

const { API_BASE_URL } = getClientConfig();

export default function DashboardLayout({ children }) {
  const [licenseValid, setLicenseValid] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleLogout = () => {
    localStorage.removeItem('auth_token');
    window.location.href = '/';
  };

  const token = localStorage.getItem('auth_token');

  let isSuperUser = false;
  let hasActivityLogAccess = false;
  let hasDashboardAccess = false;

  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    isSuperUser = payload?.admin === true;
    hasActivityLogAccess = payload?.activity_log_access === true;
    hasDashboardAccess = payload?.dash_access === true;
  } catch (_) {}

  useEffect(() => {
    fetch(`${API_BASE_URL}/license-status`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(res => res.json())
      .then(data => setLicenseValid(data.valid))
      .catch(() => setLicenseValid(true));
  }, [token]);

  return (
    <div className="flex h-screen bg-gray-100 text-gray-800 relative">
      {(mobileOpen || window.innerWidth >= 768) && (
        <aside
          className={`z-40 top-0 left-0 h-full transition-all duration-200 ease-in-out bg-white border-r border-gray-200 shadow-sm
          ${mobileOpen ? 'absolute w-64' : 'absolute md:relative'}
          md:w-20 md:hover:w-64 group flex flex-col justify-between`}
        >
          <div className="p-4 space-y-8">
            <div className="flex items-center space-x-2">
              <ShieldCheck className="text-blue-600" />
              <span className={`text-xl font-bold tracking-wider text-gray-800 ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>
                IP PORTAL
              </span>
            </div>
            <nav className="space-y-2 text-sm mt-4">
              {hasDashboardAccess && (
                <a href="/dashboard" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <ShieldCheck className="w-4 h-4 text-purple-500" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Dashboard</span>
                </a>
              )}
              <a href="/logs" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                <FileSearch2 className="w-4 h-4 text-blue-500" />
                <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>IPDR Logs</span>
              </a>
              {isSuperUser && (
                <a href="/nas-manage" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <ActivitySquare className="w-4 h-4 text-blue-500" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>NAS Management</span>
                </a>
              )}
{isSuperUser && (
  <a href="/settings" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
    <Settings className="w-4 h-4 text-green-600" />
    <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Settings</span>
  </a>
)}
{isSuperUser && (
  <a href="/network/manage" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
    <Network className="w-4 h-4 text-blue-600" />
    <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Network Management</span>
  </a>
)}
{isSuperUser && (
  <a href="/radius/sources" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
    <Radio className="w-4 h-4 text-orange-500" />
    <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>RADIUS Sources</span>
  </a>
)}
              {hasActivityLogAccess && (
                <a href="/activity" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <Clock className="w-4 h-4 text-indigo-500" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Activity Logs</span>
                </a>
              )}
              {isSuperUser && (
                <a href="/lic-status" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <Settings className="w-4 h-4 text-yellow-600" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>License Info</span>
                </a>
              )}
              {/* Voice Menu */}
              <div className="border-t pt-4 mt-4 space-y-2">
                <a href="/voice/cdr" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <ListMusic className="w-4 h-4 text-pink-600" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Voice CDR</span>
                </a>
                {/* <a href="/voice/sip-trace" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <Voicemail className="w-4 h-4 text-red-600" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>SIP Trace Logs</span>
                </a> */}
                <a href="/voice/customers" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <UsersRound className="w-4 h-4 text-blue-600" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Voice Clients</span>
                </a>
                {/* <a href="/voice/active-calls" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <PhoneForwarded className="w-4 h-4 text-purple-600" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Active Calls</span>
                </a> */}
                {/* <a href="/voice/billing/rates" className="flex items-center space-x-2 py-2 px-3 rounded-md hover:bg-gray-100">
                  <Banknote className="w-4 h-4 text-green-700" />
                  <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline`}>Rate Cards</span>
                </a> */}
              </div>
            </nav>
          </div>
          <div className="p-4 border-t border-gray-200 flex items-center justify-between bg-gray-50">
            <div className="flex items-center space-x-2 text-sm">
              <User className="w-4 h-4 text-gray-500" />
              <span className={`ml-1 ${mobileOpen ? 'inline' : 'hidden'} group-hover:inline text-gray-700 font-medium`}>
                {isSuperUser ? 'Admin' : 'User'}
              </span>
            </div>
            <button onClick={handleLogout} title="Logout">
              <LogOut className="w-5 h-5 text-gray-400 hover:text-red-500" />
            </button>
          </div>
        </aside>
      )}

      <main className="flex-1 flex flex-col overflow-hidden">
        <header className="h-14 border-b border-gray-200 px-4 md:px-6 flex items-center justify-between bg-white shadow-sm">
          <button
            className="md:hidden p-1 rounded hover:bg-gray-100"
            onClick={() => setMobileOpen(prev => !prev)}
          >
            <Menu className="w-5 h-5 text-gray-700" />
          </button>
          <div className="text-sm font-semibold text-blue-600">GOSOFT LAB</div>
          <div className="text-xs text-gray-500">Network Intelligence Access Panel</div>
        </header>

        {!licenseValid && (
          <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-2 text-center text-sm font-medium">
            🚫 License violation: System access restricted. <a href="/lic-status"><u>License Info</u></a>
          </div>
        )}

        <div className="flex-1 overflow-y-auto p-6 bg-gray-50">
          {children}
        </div>
      </main>
    </div>
  );
}